import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden fixed inset-0 z-10" }
const _hoisted_2 = { class: "px-4 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "inline-block h-screen align-middle",
  "aria-hidden": "true"
}, " ​ ", -1)
const _hoisted_4 = { class: "inline-block w-full max-w-[24rem] md:max-w-2xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-md" }
const _hoisted_5 = { class: "flex flex-col md:flex-row" }
const _hoisted_6 = { class: "p-4 md:flex-1" }
const _hoisted_7 = { class: "aspect-w-16 aspect-h-16" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex flex-col p-4 md:flex-1 md:p-8 md:pb-4" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "text-sm text-gray-500" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { computed } from "vue";
import { useStore } from "vuex";
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
  DialogTitle,
} from "@headlessui/vue";

import { IProduct } from "@/interfaces/IProduct";
import { getProductImage } from "@/helpers/get-product-image";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const isOpen = computed(() => store.state.productDialogOpen);
const openingProduct = computed(() => store.state.openingProductOnDialog);
const productImageUrl = computed(() =>
  getProductImage(openingProduct.value.image.url)
);

const closeDialog = () => {
  store.commit("TOGGLE_PRODUCT_DIALOG");
  setTimeout(() => {
    document.querySelector("html")?.classList.remove("headless-ui-dialog-fix");
  }, 500);
};

const shoppingCartList = computed(() => store.state.shoppingCartList);

const addedInCart = computed(() =>
  shoppingCartList.value.find(
    (product: IProduct) => product.id === openingProduct.value.id
  )
);

const addToCart = () => {
  if (addedInCart.value !== undefined) {
    store.dispatch("updateQuantity", {
      productId: openingProduct.value.id,
      type: "+",
    });
  } else {
    store.commit("ADD_TO_CART", openingProduct.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: _unref(isOpen),
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), {
                    class: "fixed inset-0",
                    style: {"background-color":"rgba(255, 255, 255, 0.3)"}
                  })
                ]),
                _: 1
              }),
              _hoisted_3,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("img", {
                            src: _unref(productImageUrl),
                            class: "rounded-md"
                          }, null, 8, _hoisted_8)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg font-medium leading-6 text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(openingProduct).name), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(openingProduct).description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, "$ " + _toDisplayString(_unref(openingProduct).price), 1),
                        _hoisted_13,
                        _createElementVNode("div", { class: "mt-4" }, [
                          _createElementVNode("button", {
                            class: "p-2.5 w-full text-white uppercase outline-none bg-primary",
                            onClick: addToCart
                          }, " Add To Cart ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})